module.exports = {"pageTitleText":"HTML頁面","createText":"Create","groupName":"Group Name","htmlPageName":"Page Name","status":"Status","sections":{"essential":"Essential"},"isPresentHtmlPageFromLocal":"從EDGE回傳HTML頁面"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/htmlPage.json
// module id = xEtN
// module chunks = 3